import React from 'react'
import { Spinner } from './Spinner'

interface SentinelLoaderProps {
  /** Attach this ref to the sentinel div for IntersectionObserver */
  sentinelRef?: React.RefObject<HTMLDivElement>
  /** Show the spinner + text when true */
  isFetching: boolean
  /** Text shown next to spinner. Defaults to "Loading more…" */
  label?: string
  style?: React.CSSProperties
  className?: string
}

export const SentinelLoader = React.forwardRef<HTMLDivElement, Omit<SentinelLoaderProps, 'sentinelRef'>>(
  ({ isFetching, label = 'Loading more…', style, className }, ref) => (
    <div
      ref={ref}
      className={className}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0.75rem 0',
        minHeight: '1px',
        ...style,
      }}
    >
      {isFetching && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.8rem', color: 'var(--text-muted)' }}>
          <Spinner size={14} />
          {label}
        </div>
      )}
    </div>
  )
)
SentinelLoader.displayName = 'SentinelLoader'
